/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningssortascending2Inputs */

const en_earningssortascending2 = /** @type {(inputs: Earningssortascending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ascending`)
};

const de_earningssortascending2 = /** @type {(inputs: Earningssortascending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aufsteigend`)
};

/**
* | output |
* | --- |
* | "ascending" |
*
* @param {Earningssortascending2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningssortascending2 = /** @type {((inputs?: Earningssortascending2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningssortascending2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningssortascending2(inputs)
	return de_earningssortascending2(inputs)
});
export { earningssortascending2 as "earningsSortAscending" }